import React, { useState, useEffect, useRef, memo } from 'react'

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
// Libraries
import { Link } from "react-router-dom";
import { m } from "framer-motion";

// Components
import Filter from "../Portfolio/Filter";

// Data
import axios from 'axios';
import config from '../../config';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StoryWide = ({ filterData, grid, loading, setLoading }) => {
    const shopWrapper = useRef();
    const [stories, setStories] = useState([]);
    const [filteredStories, setFilteredStories] = useState([]);
    const [activeFilter, setActiveFilter] = useState("recent-stories");
    const [favorites, setFavorites] = useState([]); // État pour suivre les favoris


    useEffect(() => {
        const fetchStories = async () => {
            try {
                const response = await axios.get(config.REACT_APP_API_URL + "/allproduct_actif");
                setStories(response.data?.result);
                setLoading(false);

                // Récupérer les favoris de l'utilisateur (si connecté)
                const token = localStorage.getItem('accessToken');
                if (token) {
                    const favoritesResponse = await axios.get(`${config.REACT_APP_API_URL}/get-favorites`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    setFavorites(favoritesResponse.data.favorites || []);
                }
            } catch (error) {
                console.error("Error fetching stories:", error);
            }
        };
        fetchStories();
    }, [setLoading]);

    useEffect(() => {
        if (stories.length > 0) {
            let filtered = [];
            if (activeFilter === "recent-stories") {
                // Afficher les 6 derniers produits NON spéciaux
                filtered = stories.filter(item => !item.special).slice(0, 8);
            } else if (activeFilter === "special-stories") {
                // Afficher les 6 derniers produits spéciaux
                filtered = stories.filter(item => item.special).slice(0, 8);
            }
            setFilteredStories(filtered);
        }
    }, [activeFilter, stories]);

    // Fonction pour ajouter une story au panier
    const handleAddToBasket = async (productId) => {
        const token = localStorage.getItem("accessToken");

        if (!token) {
            toast.error("Veuillez vous connecter pour ajouter au panier");
            return;
        }

        try {
            const response = await axios.post(
                `${config.REACT_APP_API_URL}/add-to-basket`,
                { productId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            toast.success(response.data.message);
        } catch (error) {
            toast.error(error.response?.data?.message || "Erreur lors de l'ajout au panier");
        }
    };
    // Méthode pour basculer l'état des favoris
    const handleToggleFavorite = async (productId) => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            toast.error('Veuillez vous connecter pour gérer vos favoris');
            return;
        }

        try {
            const response = await axios.post(
                `${config.REACT_APP_API_URL}/toggle-favorite`,
                { productId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            // Mettre à jour l'état local des favoris
            if (favorites.includes(productId)) {
                setFavorites(favorites.filter(id => id !== productId));
            } else {
                setFavorites([...favorites, productId]);
            }
            toast.success(response.data.message);
        } catch (error) {
            toast.error(error.response?.data?.message || 'Erreur lors de la gestion des favoris');
        }
    };

    return (
        <div className="grid-wrapper">
            <Filter title="Produits" filterData={filterData}
                activeFilter={activeFilter}
                onFilterChange={setActiveFilter} />
            <ul ref={shopWrapper} className={`grid grid-cols-1 min-sm:grid-cols-2 min-md:grid-cols-3 min-lg:grid-cols-4 p-4 gap-4 ${grid} ${loading ? "loading" : ""}`}>

                {filteredStories.map((item, i) => (
                    <li key={i} className={`grid-item ${item.category}`}>
                        <m.div
                            initial={{ opacity: 0 }}
                            whileInView={!loading && { opacity: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6, ease: "easeOut" }}
                            className="product-box relative overflow-hidden w-full mb-[45px] xs:mb-0">
                            <Link aria-label="link" to={`/single-product/${item._id}`}>
                                <div className="product-image relative overflow-hidden rounded-md">
                                    {item.picture && <img className="default-image w-[768px] h-[400px]" src={config.REACT_APP_API_URL + item.picture} alt="" />}
                                    {item.picture && <img className="hover-img w-[768px] h-[400px]" src={config.REACT_APP_API_URL + item.picture} alt="" />}

                                    <div className="product-overlay absolute top-0 left-0 w-full h-full"></div>
                                    <div className="product-hover-bottom absolute bottom-0 w-full left-0 transition-default py-[35px] text-center">
                                        <OverlayTrigger overlay={(props) => (<Tooltip className="text-xxs font-serif" {...props}>ADD TO CART</Tooltip>)} placement="top"><Link aria-label="shopwide" to="#" rel="noreferrer"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleAddToBasket(item._id);
                                            }}
                                            className="product-link-icon move-top-bottom relative rounded-full bg-[#fff] text-darkgray inline-block text-center transition-default m-[5px] h-[40px] w-[40px] leading-[42px]">
                                            <i className="feather-shopping-cart m-0 text-base "></i>
                                        </Link></OverlayTrigger>
                                        
                                    </div>

                                </div>
                            </Link>
                            <div className="product-footer flex flex-col text-center py-[25px] xs:py-[10px]">
                            <Link aria-label="link" to={`/single-product/${item._id}`} className="text-[#828282] hover:text-[#828282] font-medium ">{item.category.name}</Link>
                                <Link aria-label="link" to={`/single-product/${item._id}`} className="text-darkgray hover:text-black font-medium inline-block">{item.code}</Link>
                                <Link aria-label="link" to={`/single-product/${item._id}`} className="text-[20px] text-darkgray hover:text-black font-medium inline-block">{item.name}</Link>
                               
                            </div>
                        </m.div>
                    </li>
                ))}
            </ul>
        </div>
    );
};


export default memo(StoryWide);
